import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { mediatipFeatureName } from './store/state';
import { reduceMediatips } from './store/reducer';
import { MediatipEffects } from './store/effects';
import { MediatipService } from '@app/common/services/mediatip.service';
import { SignalMessageService } from '@app/common/services/signalmessage.service';

@NgModule({
    imports: [
        StoreModule.forFeature(mediatipFeatureName, reduceMediatips),
        EffectsModule.forFeature([MediatipEffects])
    ], providers: [MediatipService, SignalMessageService]
})
export class MediatipStateModule { }
